/**
 * Cart Validation for Nootro Energy Pouches
 * Removes all 1 pack variants if total quantity drops below 3
 */

(function() {
  // The three 1 pack variant IDs that must have a minimum of 3 total
  const BUNDLE_VARIANT_IDS = [
    56201298673830, // Frosty Mint 1 Pack
    56201298706598, // Grapefruit 1 Pack
    56201298739366  // Lemon Lime 1 Pack
  ];

  let isValidating = false;

  // Function to check cart and remove variants if needed
  async function validateCart() {
    if (isValidating) return;
    isValidating = true;

    try {
      console.log('Checking cart...');
      
      // Get current cart
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      console.log('Cart items:', cart.items);
      
      // Calculate total quantity of our bundle variants
      let totalBundleQty = 0;
      const bundleItemKeys = [];
      
      cart.items.forEach(item => {
        console.log('Item variant_id:', item.variant_id);
        if (BUNDLE_VARIANT_IDS.includes(item.variant_id)) {
          totalBundleQty += item.quantity;
          bundleItemKeys.push(item.key);
        }
      });
      
      console.log('Total bundle quantity:', totalBundleQty);
      
      // If total is below 3 and there are bundle items, remove them all
      if (totalBundleQty > 0 && totalBundleQty < 3) {
        console.log('⚠️ Bundle quantity below minimum (3), removing all bundle items...');
        
        // Build updates object to set all bundle items to 0
        const updates = {};
        bundleItemKeys.forEach(key => {
          updates[key] = 0;
        });
        
        console.log('Removing items:', updates);
        
        // Update cart to remove items
        const updateResponse = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates })
        });
        
        if (updateResponse.ok) {
          console.log('✅ Bundle items removed successfully');
          // Reload the page to reflect changes
          window.location.reload();
        } else {
          console.error('Failed to update cart');
        }
      } else {
        console.log('✅ Cart is valid');
      }
    } catch (error) {
      console.error('Cart validation error:', error);
    } finally {
      isValidating = false;
    }
  }

  // Run validation after a delay
  function scheduleValidation() {
    setTimeout(validateCart, 800);
  }

  // Listen for cart changes
  function attachListeners() {
    // Listen for any form submission in cart
    document.addEventListener('submit', function(e) {
      if (e.target.closest('form[action*="/cart"]')) {
        console.log('Cart form submitted');
        scheduleValidation();
      }
    });

    // Listen for quantity input changes
    document.addEventListener('input', function(e) {
      if (e.target.name && e.target.name.includes('updates')) {
        console.log('Quantity input changed');
        scheduleValidation();
      }
    });

    // Listen for clicks on cart update/remove buttons
    document.addEventListener('click', function(e) {
      const target = e.target;
      
      // Check for remove buttons
      if (target.closest('[href*="/cart/change"]') ||
          target.closest('.cart__remove') ||
          target.closest('[data-cart-remove]') ||
          target.closest('.cart-item__remove')) {
        console.log('Remove button clicked');
        scheduleValidation();
      }
      
      // Check for quantity buttons
      if (target.closest('[name="plus"]') ||
          target.closest('[name="minus"]') ||
          target.closest('.quantity__button') ||
          target.closest('[data-quantity-button]')) {
        console.log('Quantity button clicked');
        scheduleValidation();
      }
    });
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      attachListeners();
      validateCart();
    });
  } else {
    attachListeners();
    validateCart();
  }

  // Also listen for Shopify cart updates (theme-specific)
  document.addEventListener('cart:updated', scheduleValidation);
  document.addEventListener('cart:refresh', scheduleValidation);
})();

